import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'components/UI/HtmlParser';
import { isEmpty } from 'lodash';
import { withFormHandler } from '../FormComponent';

function TextInput({
    className,
    readOnly,
    onChange,
    placeholder,
    path,
    type,
    value,
    icon,
    errorClassName,
    error,
    printErrors,
    disabled,
    iconMessage,
    onEnter,
})
{
    const [active, setActive] = useState(false);
    const handleChange = (e) =>
    {
        if (onChange) onChange(e.target.value, path);
    };

    let val = value;
    if (type === 'text' && value === null) val = '';

    if (type === 'number')
    {
        if (value !== null && value !== '') val = Number(value);
        else val = '';
    }

    const inputClassName = isEmpty(className) ? 'tw-h-8 tw-bg-neutral-lightest' : className;
    const bgColor = disabled ? 'tw-bg-gray-200 dark:tw-bg-neutral-700 tw-opacity-25 ' : ' tw-bg-gray-50 dark:tw-bg-neutral-600';

    const style = { opacity: disabled ? 0.5 : 1 };

    const parsedError = Array.isArray(error) ? error[0] ?? '' : error;
    const errorContent = parsedError && printErrors ? (
        <span
            className={`${errorClassName} tw-flex tw-text-sm tw-text-red-600 dark:tw-text-[#FF565D]`}
        >{ReactHtmlParser(parsedError)}</span>
    ) : null;

    const handleKeyDown = (event) =>
    {
        if (event.key === 'Enter' && onEnter)
        {
            onEnter(event);
        }
    };

    return (

        <>
            <div
                className={`tw-w-full tw-relative tw-h-fit tw-py-1.5 tw-rounded tw-px-3 tw-border ${active && !disabled ? 'tw-border-primary-default dark:tw-border-white tw-bg-white dark:tw-bg-neutral-600 ' : bgColor} dark:tw-border-gray-400 hover:tw-border-primary-default`}
            >
                <input
                    onFocus={() =>
                    {
                        setActive(true);
                    }}
                    onBlur={() =>
                    {
                        setActive(false);
                    }}
                    readOnly={readOnly}
                    className={`tw-transition-all tw-w-full tw-outline-none tw-border-0 ${inputClassName}`}
                    type={type}
                    value={val}
                    placeholder={placeholder}
                    onChange={handleChange}
                    disabled={disabled}
                    onKeyDown={handleKeyDown}
                    style={style}
                />
                {icon && (
                    <FontAwesomeIcon
                        data-toggle="tooltip"
                        title={iconMessage}
                        className="tw-absolute tw-right-2 tw-top-auto tw-bottom-auto tw-mt-1.5"
                        icon={icon}
                    />
                )}
            </div>
            {errorContent}
        </>
    );
}

TextInput.defaultProps = {
    type: 'text',
    readOnly: false,
    error: '',
    printErrors: true,
    iconMessage: '',
    onEnter: null,
};

TextInput.propTypes = {
    className: PropTypes.string,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    path: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    icon: PropTypes.any,
    errorClassName: PropTypes.string,
    error: PropTypes.node,
    printErrors: PropTypes.bool,
    disabled: PropTypes.bool,
    iconMessage: PropTypes.string,
    onEnter: PropTypes.func,
};

export default withFormHandler(TextInput);
